import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Routes } from './app/routes';
import { ThemeProvider } from '@emotion/react';
import DefaultTheme from './app/theme/DefaultTheme';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { store } from './stores/redux/store';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={DefaultTheme}>
                <Routes />
            </ThemeProvider>
            <CssBaseline enableColorScheme />
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
